module.exports = __webpack_public_path__ + "static/img/1.c6e9182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/1.png
// module id = KBGf
// module chunks = 12